import { useCallback, useRef } from 'react';

/**
 * Returns a stable event callback that always calls the latest version of the handler.
 *
 * This is only safe to use for event handlers (e.g., onClick, onChange, WebSocket, timers).
 * Do NOT call this during render.
 */
export const useEventHandler = <T extends (...args: any[]) => any>(
  callback: T,
): T => {
  const callbackRef = useRef<T>(callback);
  callbackRef.current = callback;

  const staticCallback = useCallback(
    (...args: Parameters<T>) => callbackRef.current(...args),
    [],
  ) as T;

  return staticCallback;
};
